import styles from './OutrightCard.module.scss';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import VisibilitySensor from 'react-visibility-sensor';
import { mbnColorPicker } from '../../../../../utils/helpers';
import moment from 'moment';
import Outcomes from '../Outcomes/Outcomes';

const OutrightCard = props => {
    const { market, season } = props;

    const locale = useSelector(state => state.settings.locale);

    const [collapsedAccordionItems, setCollapsedAccordionItems] = useState([]);

    const isCollapsed = collapsedAccordionItems.find(item => item === market.id);
    const mbnColor = mbnColorPicker(market.mbn);

    const onCollapseChange = (id, isCollapsed) => {
        let newCollapsedItems = [];

        if (isCollapsed) {
            newCollapsedItems = collapsedAccordionItems.filter(item => item !== id);
        } else {
            newCollapsedItems = collapsedAccordionItems.concat(id);
        }

        setCollapsedAccordionItems(newCollapsedItems);
    };

    return (
        <VisibilitySensor key={market.id} partialVisibility={true} scrollCheck={true}>
            {({ isVisible }) => {
                return isVisible ? (
                    <div className={styles.accordionItem}>
                        <div
                            className={styles.accordionHeader}
                            onClick={() => onCollapseChange(market.id, isCollapsed)}
                        >
                            <div className={styles.accordionHeaderContent}>
                                <div className={styles.seasonName}>
                                    <img
                                        alt={season.countryCode}
                                        src={`/assets/flags/${
                                            season.countryCode?.trim() ? season.countryCode : 'int'
                                        }.svg`}
                                        className={styles.flag}
                                    />
                                    <span>{market.names?.[locale]}</span>
                                </div>
                                {/*<span className={styles.programCode}>{season.programCode}</span>*/}
                                <span className={styles.mbn} style={{ backgroundColor: mbnColor }}>
                                    {market.mbn}
                                </span>
                                {/*<img*/}
                                {/*    className={styles.infoIcon}*/}
                                {/*    src={InfoIcon}*/}
                                {/*/>*/}
                            </div>
                            <div className={styles.nextBetStopDate}>
                                {market.nextBetStopDate && (
                                    <span className={styles.nextBetStopDate}>
                                        Next Bet Stop Date :{' '}
                                        {moment(market.nextBetStopDate).format('DD/MM/YYYY')}
                                    </span>
                                )}

                                <span className={`${styles.accordionArrowIcon} icon-arrow-down`} />
                            </div>
                        </div>
                        <div
                            className={`${styles.accordionContent} ${
                                isCollapsed ? 'd-hidden' : ''
                            }`}
                        >
                            <Outcomes market={market} season={season} />
                        </div>
                    </div>
                ) : (
                    <div style={{ height: '40px', marginBottom: '20px' }} />
                );
            }}
        </VisibilitySensor>
    );
};

export default OutrightCard;
